import React from 'react';
import './NewCollections.css'
import Item from '../Item/Item';
import { products } from '../../data/products';

const NewCollections = () => {
    const new_collection = [...products].sort((a, b) => new Date(b.date) - new Date(a.date)).slice(0, 8);

    return (
        <div className='new-collections'>
            <div className="new-collections-header">
                <h2>New Arrivals</h2>
                <p>Fresh additions to elevate your home</p>
            </div>

            <div className="collections">
                {new_collection.map((item, i) => {
                    return <Item key={i} id={item.id} name={item.name} image={item.image} new_price={item.new_price} old_price={item.old_price}/>
                })}
            </div>
        </div>
    )
}

export default NewCollections
